import React from 'react';
import {useStyles} from '../../../../../../shared/hooks/styles';
import Screen from '../../../../../../shared/components/screen';
import {View} from 'react-native';
import {ProfileApplicationsItem} from '../../../../common/applications/item';
import {ProvidingListApplication} from '../../../../../../shared/models/api';
import {CustomScrollView} from '../../../../../../shared/components/scrollView';

export const ProfileApplicationsItemMobile: React.FC<{application: ProvidingListApplication}> = ({application}) => {
  const styles = useStyles(({theme}) => ({
    container: {
      marginTop: 16,
      paddingHorizontal: 35,
      paddingBottom: theme.screen.bottomOffset,
    },
  }));

  return (
    <Screen>
      <CustomScrollView contentInsetAdjustmentBehavior='automatic'>
        <View style={styles.container}>
          <ProfileApplicationsItem application={application} />
        </View>
      </CustomScrollView>
    </Screen>
  );
};
